import { render } from "./TheTransition.vue?vue&type=template&id=0591f9cf"
const script = {}

import "./TheTransition.vue?vue&type=style&index=0&id=0591f9cf&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__